import { useState } from 'react';
import { TextField, InputAdornment, IconButton, TextFieldProps } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';

export type FormPasswordFieldProps<T extends FieldValues> = Omit<TextFieldProps, 'type'> & {
  name: Path<T>;
  control: Control<T>;
};

const FormPasswordField = <T extends FieldValues>({ name, control, ...textFieldProps }: FormPasswordFieldProps<T>) => {
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => setShowPassword(!showPassword);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          value={field.value ?? ''}
          {...textFieldProps}
          type={showPassword ? 'text' : 'password'}
          slotProps={{
            ...textFieldProps.slotProps,
            input: {
              ...textFieldProps.slotProps?.input,
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton
                    onClick={toggleShowPassword}
                    edge='end'
                    disabled={textFieldProps.disabled}
                    sx={{ color: 'neutral.300' }}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
        />
      )}
    />
  );
};

export default FormPasswordField;
